<template>
  <v-container>
    <v-card class="mx-auto" flat>
      <v-row>
        <v-col>
          <p class="headline font-weight-bold" style="color:#AF8936; font-size: 27px !important;">
             Publicación de Edictos
          </p>
        </v-col>
      </v-row>
      <v-divider class="mb-9"></v-divider>
      <v-alert
        v-if="message"
        border="left"
        colored-border
        color="orange"
        elevation="2"
      >
      {{message}}
      </v-alert>

      <v-dialog
        v-model="progressLoading"
        hide-overlay
        persistent
        width="300"
      >
        <v-card
          color="grey darken-2"
          dark
        >
          <v-card-text>
            Cargando Edicto...
            <v-progress-linear
              indeterminate
              color="white"
              class="mb-0"
            ></v-progress-linear>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-card>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex';
const Swal = require('sweetalert2');
  export default {
    props: ['id'],
    data: () => ({
      progressLoading: false,
      message: '',
    }),
    mounted(){
      this.getFile()
    },
    methods:{
      getFile(){
        this.progressLoading = true
        var edicto_id = 0
        edicto_id = parseInt(this.id)
        if ( edicto_id != this.id ) {
          this.message = "EL DOCUMENTO NO EXISTE"
          this.progressLoading = false
          return false;
        }
        this.$store.dispatch("GET_FILE_EDICTOS", { id: edicto_id, modo: 'descargar' }).then((response) => {
          const res = Array.isArray(response) ? response[0] : response;
          console.log(res);
          const url = res.data.data.url;
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', edicto_id + '.pdf');
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          this.progressLoading = false
          this.message = "EL DOCUMENTO SE HA DESCARGADO"
          this.$swal({
            title: 'Documento descargado correctamente!!!',
            icon: 'success'
          })
        })
        .catch(err => {
          this.message = "El documento NO existe !!!!"
          this.$swal({
            title: 'Error al descargar el edicto, verifique la url.',
            icon: 'error'
          })
          this.progressLoading = false
          console.log(err);
        });
      },
    }
  }
</script>
